import { Moment } from 'moment';

type RemainingTime = {
  amount?: number;
  scale: 'days' | 'hours';
};

export const remainingTime = (date: Moment): RemainingTime => {
  let scale: 'days' | 'hours' = 'days';
  let expireIn = date.diff?.(new Date(), 'days');

  if (expireIn === 0) {
    expireIn = date.diff?.(new Date(), 'hours');
    if (expireIn < 0) {
      expireIn = 0;
    }
    scale = 'hours';
  } else if (expireIn < 0) {
    expireIn = 0;
    scale = 'hours';
  }

  return {
    amount: expireIn,
    scale,
  };
};
